import { Input, Typography } from '@breetometer/components';
import type { ICheckbox } from 'BreetHelpers';
import { forwardRef, type Ref } from 'react';

const Checkbox = forwardRef(({ errorMsg, register, children, ...rest }: ICheckbox, ref) => (
	<div className='bt_checkbox'>
		<div className='bt_checkbox_content'>
			<Input
				ref={ref as Ref<HTMLInputElement>}
				type='checkbox'
				data-testid='checkbox'
				label=''
				id=''
				{...rest}
				{...register}
			/>

			{children}
		</div>

		{!!errorMsg && <Typography className='bt_checkbox_error_message color-error-400'>{errorMsg}</Typography>}
	</div>
));

export default Checkbox;

Checkbox.displayName = 'BTCheckbox';
